// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"330":"registrationViews","730":"publicViews","985":"quoteViews"}[chunkId] + "-legacy." + {"330":"26caeb13","730":"e1897be2","985":"583662fc"}[chunkId] + ".js";
};